import React from "react";

const Footer = () => {
  return (
    <div className="bg-black py-5 text-center text-green-500 font-roboto">
      Copyright @2023 . Jawad!
    </div>
  );
};

export default Footer;
